import { SegmentedControl } from "@radix-ui/themes";
import { useI18n } from "@/i18n";
import type { CategoryKey } from "@/types";

const CATEGORIES: CategoryKey[] = ["currency", "interest", "index"];

interface CategoryTabsProps {
  value: CategoryKey;
  onChange: (category: CategoryKey) => void;
}

export function CategoryTabs({ value, onChange }: CategoryTabsProps) {
  const { t } = useI18n();

  return (
    <SegmentedControl.Root
      value={value}
      onValueChange={(v) => onChange(v as CategoryKey)}
      size="2"
      className="rk-category-tabs"
    >
      {CATEGORIES.map((category) => (
        <SegmentedControl.Item key={category} value={category}>
          {t(`category.${category}`)}
        </SegmentedControl.Item>
      ))}
    </SegmentedControl.Root>
  );
}
